module.exports = __webpack_public_path__ + "img/microplastics-1.3b95e63e.png";